import Controls from "../components/Controls";
import { useTranslation } from "../components/Localization";
import RoomHeader from "../components/RoomHeader";
import { getGameScore } from "../services/gameScores";
import { usePageGame } from "../hooks/usePageGame";

export default function LegacyScorePage() {
  const { t } = useTranslation();
  const { game } = usePageGame("mariaffiek", "escape");
  const escapeScore = getGameScore("escape");
  return <main className="screen score legacy-score">
    <RoomHeader roomId="legacy" />
    <div className="score-copy">
      <strong>{t("common.completed")}</strong>
      <div>{Array.from({ length: 4 }, (_, index) => <i key={index} />)}</div>
      <span>4/4</span>
      {game && <div className="room-score-results">
        <p>{t("score.escapeResult", { score: escapeScore, max: 15 })}</p>
      </div>}
    </div>
    <Controls backTo="/mariaffiek/telefon" nextTo="/vilaghaboru" />
  </main>;
}
